// JS ``string.length`` counts UTF-16 code units, which diverges from codepoints
// for non-BMP characters (e.g. most emoji). Iterating yields codepoints,
// matching Python ``len`` and most backend length limits.
export const countCodepoints = (value: string): number => [...value].length;

interface CharacterCountProps {
  value: string;
  limit: number;
}

/** Codepoint ``count/limit`` counter with over-limit error styling. */
export function CharacterCount({ value, limit }: CharacterCountProps) {
  const count = countCodepoints(value);
  const overLimit = count > limit;
  return (
    <span
      aria-live="polite"
      className={`ml-auto flex-shrink-0 whitespace-nowrap pl-2 text-xs font-raleway lining-nums tabular-nums ${
        overLimit ? 'rounded-md bg-red-100 px-1.5 py-0.5 font-semibold text-content-danger' : 'text-content-subtle'
      }`}
    >
      {count}/{limit}
    </span>
  );
}
